import { create } from 'zustand';

interface AiChatState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useAiChatStore = create<AiChatState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
